import ResponsiveImage from 'components/Common/ResponsiveImage'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { getSupportContact } from 'selectors/supportContactSelector'
import { connect } from 'react-redux'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextButton from 'components/Luxkit/Button/TextButton'

const CardContent = styled.div``

const CardActions = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${props => props.theme.palette.neutral.five};
  padding: ${rem(16)};
  height: 100%;
  align-items: center;

  ${mediaQueryUp.tablet} {
    align-items: flex-start;
    border-top: none;
    border-left: 1px solid ${props => props.theme.palette.neutral.five};
    padding: 0 0 0 ${rem(24)};
  }
`

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem(16)};
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)};
    gap: ${rem(24)};
    flex-direction: row;
    align-items: center;

    > ${CardContent} {
      flex-grow: 1;
    }

    > ${CardActions} {
      flex-shrink: 0;
    }
  }
`

const CardImageContainer = styled.div`
  > * {
    height: 100%;
  }
`

const TextButtonWrapper = styled(TextButton)`
  margin-top: ${rem(8)};
`

const UnavailabilityCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${props => props.theme.palette.neutral.five};
  background-color: ${props => props.theme.palette.neutral.eight};

  ${mediaQueryUp.tablet} {
    flex-direction: row;
  }

  > ${CardImageContainer} {
    flex-basis: ${rem(230)};
  }

  > ${CardBody} {
    flex-grow: 1;
  }
`

interface Props {
  offerVariation: Tours.V2OfferVariation
  currentContact: App.GeoContacts
}

function TourV2UnavailabilityCard(props: Props) {
  const { offerVariation, currentContact } = props
  const contact = currentContact[currentContact.default]
  const offerImage = offerVariation.images[0]

  return <UnavailabilityCard>
    {!!offerImage && <CardImageContainer>
      <ResponsiveImage aspectRatio="5:3" id={offerImage.id} mobileWidth="230px" fit="center" />
    </CardImageContainer>}
    <CardBody>
      <CardContent>
        <Heading variant="heading5">Sorry, this offer has sold out!</Heading>
        <BodyText variant="medium">{offerVariation.name}</BodyText>
      </CardContent>
      <CardActions>
        <BodyText variant="medium" weight="bold">Still interested?</BodyText>
        <BodyText variant="medium">Call us to be added to the waitlist</BodyText>
        <TextButtonWrapper
          kind="primary"
          href={`tel:${contact.number}`}
          startIcon={<LinePhoneIcon />}
        >
          Call {contact.humanReadable}
        </TextButtonWrapper>
      </CardActions>
    </CardBody>
  </UnavailabilityCard>
}

const mapStateToProps = (state: App.State) => {
  return {
    currentContact: getSupportContact(state),
  }
}

export default connect(mapStateToProps)(TourV2UnavailabilityCard)
